import moment from 'moment';
import { getSuppliers } from '../../HttpRequests/suppliers';
import { loadSuppliers } from '../State/suppliers';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const params = {
      'filter[active]': 1,
      sort: 'company_name',
      pagination: 0,
    }

    const response = await getSuppliers({ params });

    dispatch(loadSuppliers(response.data));

  } catch (error) {
    
    throw error;

  }
}
